<template>
    
  <div  v-bind="$attrs" v-on="$listeners">
    <div class="cropper-content">
      <div class="cropper" style="text-align: center">
        <vueCropper
          ref="cropper"
          :img="cropperOption.img"
            :outputSize="cropperOption.outputSize"
            :outputType="cropperOption.outputType"
            :info="cropperOption.info"
            :canScale="cropperOption.canScale"
            :autoCrop="cropperOption.autoCrop"
            :autoCropWidth="cropperOption.autoCropWidth"
            :autoCropHeight="cropperOption.autoCropHeight"
            :fixedBox="cropperOption.fixedBox"
            :fixed="cropperOption.fixed"
            :fixedNumber="cropperOption.fixedNumber"
            :canMove="cropperOption.canMove"
            :canMoveBox="cropperOption.canMoveBox"
            :original="cropperOption.original"
            :centerBox="cropperOption.centerBox"
            :infoTrue="cropperOption.infoTrue"
            :full="cropperOption.full"
            
        ></vueCropper>
      </div>
    </div>
    <div slot="footer" class="dialog-footer" style="text-align:right">
      <el-button size="small" @click="onCanel">取 消</el-button>
      <el-button size="small" type="primary" @click="finish">确认</el-button>
    </div>
      
  </div>
</template>

<script>
import { VueCropper } from 'vue-cropper'
export default {
  name: "",
  props: {
    option: {
      default: {
        img: '', // 裁剪图片的地址 url 地址, base64, blob
        outputSize: 1, // 裁剪生成图片的质量
        outputType: 'jpeg', // 裁剪生成图片的格式 jpeg, png, webp
        info: true, // 裁剪框的大小信息
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 200, // 默认生成截图框宽度
        autoCropHeight: 200, // 默认生成截图框高度
        fixedBox: false, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [1, 1], // 截图框的宽高比例 [ 宽度 , 高度 ]
        canMove: true, // 上传图片是否可以移动
        canMoveBox: true, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        full: true, // 是否输出原图比例的截图
        // enlarge: '1', // 图片根据截图框输出比例倍数
        // mode: 'contain' // 图片默认渲染方式 contain , cover, 100px, 100% auto
      },
      type: Object,
    },
  },
  components: {
    VueCropper,
 },
computed:{
  cropperOption(){
    return  this.option
  }
},
  mounted() {
    console.log(this.option);
  },
  methods: {
    finish() {
      this.$refs.cropper.getCropBlob((data) => {
        this.$emit("finishUploadEvent", data);
      });
    },
    onCanel(){
      this.$emit('update:visible', false)
    }
  },
};
</script>

<style scoped>
.cropper {
  width: 100%;
  height: 400px;
}
.dialog-footer {
  margin-top: 20px;
}
</style>

